import React from "react"
import styled from "styled-components"
import { Form } from "antd"

import Question from "../Question"
import OptionTile from "./OptionTile"
import { media } from "../../../../components/mediaStylesNew"

const Tiles = styled.div`
  display: grid;
  grid-gap: 10px;
  justify-content: space-between;
  flex-wrap: wrap;
  grid-template-columns: repeat(1, 1fr);
  @media (min-width: 66.875em) {
    justify-content: center;
    grid-template-columns: repeat(2, 1fr);
  }
`

const FormItem = styled(Form.Item)`
  position: relative;

  .ant-form-explain {
    font-family: GT America, sans-serif;
    position: absolute !important;
    top: -20px !important;
  }
`

export default class SelectionQuestion extends React.Component {
  onChange = () => {
    this.props.onSubmit(this.props.question.identifier)
  }

  render() {
    const { question, getFieldDecorator } = this.props
    return (
      <div>
        <Question {...question} />
        {getFieldDecorator && (
          <FormItem>
            {getFieldDecorator(question.identifier, {
              initialValue: this.props.value,
              rules: [
                {
                  required: this.props.question.required,
                  message: "Bitte eine Möglichkeit auswählen",
                },
              ],
              trigger: "valueChanged",
            })(
              <InputFieldWrapper
                options={this.props.options}
                question={this.props.question}
                onChange={event => this.onChange(event)}
              />
            )}
          </FormItem>
        )}
      </div>
    )
  }
}

class InputFieldWrapper extends React.Component {
  handleChange = value => {
    this.props.valueChanged(value)
    this.props.onChange(value)
  }

  render() {
    return (
      <Tiles>
        {this.props.options.map(option => (
          <OptionTile
            key={`${this.props.question.identifier}-${option.value}`}
            {...option}
            onSelect={value => this.handleChange(value)}
            selected={this.props.value === option.value}
            hasError={this.props["data-__field"].errors}
          />
        ))}
      </Tiles>
    )
  }
}
InputFieldWrapper.defaultProps = {
  onChange: () => {},
}
